import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useQuery, useMutation } from '@apollo/client';
import * as queries from '../queries';
import Swal from 'sweetalert2';
import { formatLocalTime } from '../utils/TimeUtils.js';

function Profile() {
    const { t, i18n } = useTranslation();
    const user = JSON.parse(localStorage.getItem('user'));
    const userName = user?.UserName;
    const navigate = useNavigate();

    const { data: currentServerTime, refetch: getCurrentServerTime } = useQuery(queries.GET_SERVER_CURRENT_TIME, {
        fetchPolicy: "no-cache"
    });

    const { error, data, refetch } = useQuery(queries.GET_PUNCH_RECORD, {
        variables: {
            filters: {
                UserID: parseInt(user.UserID),
                PunchOutTimeIsnull: true
            },
        },
    });

    const [punchInRecord] = useMutation(queries.PUNCH_IN_RECORD);
    const [punchOutRecord] = useMutation(queries.PUNCH_OUT_RECORD);

    const logout = () => {
        localStorage.removeItem("user");
        localStorage.removeItem("selectedLocation");
        navigate("/login", { replace: true });
    }

    const StartWorkFunction = () => {
        switch (user.UserType) {
            case 'Dispatcher':
                navigate("/dispatcher_home");
                break;
            case 'QualityInspector':
                navigate("/QA_home");
                break;
            case 'FrontDesk':
                navigate("/front_desk");
                break;
            default:
                navigate("/HomePage");
        }
    }

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
        localStorage.setItem('preferLang', lang);
    };

    const PunchInFunction = async () => {
        Swal.fire({
            title: t('Processing...'),
            text: t('Please do not refresh this page.'),
            didOpen: () => {
                Swal.showLoading();
            },
        });
        const { data } = await refetch();
        if (data.allPunchRecord.totalCount >= 1) {
            console.log("Have a previous Record")
        } else {
            try {
                const response = await punchInRecord({
                    variables: {
                        UserID: parseInt(user.UserID),
                        UserName: user.UserName,
                        UserType: user.UserType,
                    }
                });
                if (response.data.upsertPunchrecord.success) {
                    Swal.fire({
                        title: t('Punch In Successful'),
                        icon: 'success',
                        confirmButtonText: t('Okay')
                    })
                    refetch();
                } else {
                    Swal.fire({
                        title: t('Error'),
                        text: error.message,
                        icon: 'error',
                        confirmButtonText: t('Okay')
                    })
                }
            } catch (error) {
                console.error(error);
            }
        }
    }

    const PunchOutFunction = async () => {
        Swal.fire({
            title: t('Processing...'),
            text: t('Please do not refresh this page.'),
            didOpen: () => {
                Swal.showLoading();
            },
        });
        const { data } = await refetch();
        if (data.allPunchRecord.totalCount < 1) {
            console.log("No punch in Record found.")
        } else {
            const { data: newServerTime } = await getCurrentServerTime();
            try {
                const serverTime = new Date(currentServerTime?.currentTime);
                const punchInTime = new Date(data.allPunchRecord.data[0].PunchInTime);
                const diffHours = ((serverTime - punchInTime) / (1000 * 60 * 60)).toFixed(2);

                const response = await punchOutRecord({
                    variables: {
                        PunchRecordID: data.allPunchRecord.data[0].PunchRecordID,
                        PunchOutTime: newServerTime?.currentTime ? newServerTime.currentTime.replace(' ', 'T') : null,
                        WorkingHour: parseFloat(diffHours)
                    }
                });
                if (response.data.upsertPunchrecord.success) {
                    Swal.fire({
                        title: t('Punch Out Successful'),
                        icon: 'success',
                        confirmButtonText: t('Okay')
                    })
                    refetch();
                } else {
                    Swal.fire({
                        title: t('Error'),
                        text: error.message,
                        icon: 'error',
                        confirmButtonText: t('Okay')
                    })
                }
            } catch (error) {
                console.error(error);
            }
        }
    }

    return (
        <div className="main-container">
            <div className="w-full max-w-4xl bg-white p-8 mt-8 rounded shadow-lg">
                <div className="flex items-center mb-8">
                    <img src="https://placehold.co/100x100" alt="Profile picture" className="w-16 h-16 rounded-full mr-4" />
                    <div className="flex justify-between w-full">
                        <h1 className="text-2xl font-bold">{userName}</h1>
                        <button className="bg-red-500 hover:bg-red-700 text-white px-4 py-2 rounded" onClick={logout}>
                            {t('Logout')}
                        </button>
                    </div>
                </div>
                <h2 className="text-lg font-semibold mb-4">{t('Your Current Roles')}</h2>
                <ul className="mb-8">
                    <li className="flex items-center mb-2">
                        {user?.UserType}
                    </li>
                </ul>

                <h2 className="text-lg font-semibold mb-4">{t('Your Current Language')}</h2>
                <div className="mt-4 pb-2 px-2">
                    <select
                        className="max-w-xs border border-gray-300 rounded p-2"
                        id="language-select"
                        value={i18n.language}
                        onChange={e => changeLanguage(e.target.value)}
                    >
                        {['en', 'fr'].map((language, index) => (
                            <option key={index} value={language}>
                                {language === 'en' ? 'English' : 'Français'}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="mt-8">
                    {data?.allPunchRecord?.totalCount === 0 ? (
                        <>
                            <p>{t('You have not punched in yet. ')}</p>
                            <button className="bg-blue-500 hover:bg-blue-700 text-white px-4 py-2 rounded" onClick={PunchInFunction}>
                                {t('Punch In')}
                            </button>
                        </>
                    ) : (
                        <>
                            <p>{t('You have punched in at ')} {data?.allPunchRecord?.totalCount ? formatLocalTime(data.allPunchRecord.data[0].PunchInTime) : ""}</p>
                            <button className="bg-blue-500 hover:bg-blue-700 text-white px-4 py-2 rounded" onClick={PunchOutFunction}>
                                {t('Punch Out')}
                            </button>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Profile;